import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBookOpen,
  faMoon,
  faUser,
  faStar,
  faFileInvoice,
  faTableCells,
  faBuilding,
  faFileCode,
  faCircleQuestion,
  faUpload,
} from '@fortawesome/free-solid-svg-icons';

import { articles } from '../../docs/index';
import './style.css';

const iconMap = {
  'book-open': faBookOpen,
  moon: faMoon,
  user: faUser,
  star: faStar,
  'file-invoice': faFileInvoice,
  'table-cells': faTableCells,
  building: faBuilding,
  'file-code': faFileCode,
  'circle-question': faCircleQuestion,
  'upload': faUpload,
};

const DocsHome = () => {
  return (
    <>
      <Helmet>
        <title>Documentație — Programintrastat.ro</title>
      </Helmet>

      <div className="docs-home-wrapper">
        <div className="docs-home-header">
          <h1>Documentație</h1>
          <p>
            Ghid complet pentru utilizarea platformei Programintrastat.ro.
            Selectați un articol pentru a începe.
          </p>
        </div>

        <div className="docs-home-grid">
          {articles.map((a) => (
            <Link key={a.slug} to={`/docs/${a.slug}`} className="docs-home-card">
              <div className="docs-card-icon-wrap">
                <FontAwesomeIcon icon={iconMap[a.icon] || faBookOpen} />
              </div>
              <h3>{a.title}</h3>
              <p>{a.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default DocsHome;
